import { number, object, string } from 'yup';

export const softTagSchema = () => {
  return object()
    .shape({
      productionSite: string().required('Production site is required'),
      area: string().required('Area is required'),
      productionUnit: string().required('Production unit is required'),
      schedule: string().optional(),
      schedulingInterval: number()
        .nullable()
        .integer('Scheduling interval must be an integer')
        .optional()
        .when(['schedule'], {
          is: (schedule: string) => schedule && schedule.trim() !== '',
          then: schema =>
            schema
              .required(
                'Scheduling interval is required when schedule is selected'
              )
              .min(1, 'Scheduling interval must be at least 1'),
          otherwise: schema => schema.nullable().optional(),
        }),
      softTagName: string()
        .required('Soft tag name is required')
        .matches(/^[a-z0-9]+$/i, {
          message: 'Soft tag name must be alphanumeric',
        })
        .max(50, 'Soft tag name must be at most 50 characters'),
      description: string()
        .required('Description is required')
        .max(120, 'Description must be at most 120 characters'),
      signalName: string()
        .required('Signal name is required')
        .max(50, 'Signal name must be at most 50 characters'),
      unit: string()
        .required('Unit is required')
        .max(20, 'Unit must be at most 20 characters'),
      dataType: string().required('Data type is required'),
      signalType: string().required('Signal type is required'),
      owner: string().optional(),
    })
    .test(
      'schedule-interval-dependency',
      'Schedule and scheduling interval must be selected together',
      function (values) {
        const { schedule, schedulingInterval } = values;
        const hasSchedule = schedule && schedule.trim() !== '';
        const hasInterval =
          schedulingInterval !== undefined && schedulingInterval !== null;
        // Both must be provided or both must be empty
        if (hasSchedule && !hasInterval) {
          return this.createError({
            path: 'schedulingInterval',
            message:
              'Scheduling interval is required when schedule is selected',
          });
        }

        if (hasInterval && !hasSchedule) {
          return this.createError({
            path: 'schedule',
            message: 'Schedule is required when scheduling interval is chosen',
          });
        }

        return true;
      }
    );
};
